import React, { useState } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

import Icon from '@component/icon';

const OptionsButton = ({ color, onClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const className = classnames('transfer__toggle-settings', {
    'transfer__toggle-settings--open': isOpen,
  });
  const handleClick = () => {
    setIsOpen(!isOpen);
    onClick();
  };

  return (
    <button
      className={className}
      onClick={handleClick}
      aria-label="Toggle transfer settings"
    >
      <Icon type="Cog" color={color} />
    </button>
  );
};

OptionsButton.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func,
};

export default React.memo(OptionsButton);
